
import React from 'react';
import { motion } from 'framer-motion';
import { protocolData } from '../data';
import { FiExternalLink } from 'react-icons/fi';
import './CaseStatus.css';

const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
        case 'complete': return 'status-complete';
        case 'in progress': return 'status-in-progress';
        case 'pending': return 'status-pending';
        case 'aligned': return 'status-aligned';
        default: return '';
    }
};

const StatusTable = ({ items }) => (
    
        <table className="status-table">
            <thead>
                <tr>
                    <th>Item</th>
                    <th>Status</th>
                    <th>Owner/Details</th>
                </tr>
            </thead>
            <tbody>
                {items.map((item, index) => (
                    <tr key={index}>
                        <td>{item.item}</td>
                        <td>
                            <span className={`status-badge ${getStatusClass(item.status)}`}>
                                {item.status}
                            </span>
                        </td>
                        <td>{item.details}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    
);

const CaseStatus = () => {
    const { caseStatus } = protocolData;

    return (
        <motion.section
            id="case-status"
            className="section"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5 }}
        >
            <h2 className="section-title">{caseStatus.title}</h2>
            <p>{caseStatus.description}</p>
            <p>{caseStatus.goal}</p>

            <div className="drive-button-container">
                <a 
                    href={caseStatus.driveLink.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="drive-button"
                >
                    View All Evidence <FiExternalLink />
                </a>
                <p className="drive-access-note">{caseStatus.driveLink.note}</p>
            </div>

            <div className="status-grid">
                <motion.div 
                    className="status-card"
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.5 }}
                >
                    <h3>{caseStatus.evidenceCollection.title}</h3>
                    <StatusTable items={caseStatus.evidenceCollection.items} />
                </motion.div>
                <motion.div 
                    className="status-card"
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                >
                    <h3>{caseStatus.witnessReadiness.title}</h3>
                    <StatusTable items={caseStatus.witnessReadiness.items} />
                </motion.div>
            </div>
        </motion.section>
    );
};

export default CaseStatus;
